<template>
  <div>
    <div class="grid-view">
      <div class="main-content cross-delegation-markup-rule">
        <div class="app-main-inner-row">
          <div class="filters">
            <el-form :inline="true" label-width="80px" label-position="left" @submit.native.prevent>
              <div class="el-form-item-wrapper">
                <el-form-item label="委托方" class="el-form-item-w320">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Office_NoHQ"
                    :method-params="{}"
                    filterable
                    :default-value="filter.delegatorCode"
                    style="width: 100%"
                    @parentCallBack="p => { filter.delegatorCode = p.code }"
                  />
                </el-form-item>
                <el-form-item label="被委托方" class="el-form-item-w320">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Office_NoHQ"
                    :method-params="{}"
                    filterable
                    :default-value="filter.delegateeCode"
                    style="width: 100%"
                    @parentCallBack="p => { filter.delegateeCode = p.code }"
                  />
                </el-form-item>
                <el-button type="primary" size="mini" @click="toQuery">查询</el-button>
                <el-button type="primary" size="mini" @click="toCreate">新增</el-button>
                <el-button type="primary" size="mini" @click="toCopy">复制</el-button>
              </div>
            </el-form>
          </div>
        </div>
        <div ref="gridWrapper" class="section grid-wrapper">
          <cargo-ag-grid
            config-module="261607"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :side-bar="sideBarDefs"
            @selectionChanged="onSelectionChanged"
            @cellClicked="onCellClicked"
          />
        </div>
        <div>
          <cargo-pagination
            config-module="261607"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>

    <!-- 详情编辑视图 -->
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="showDetail"
      :title="dialogTitle"
      width="1000px"
      custom-class="cross-delegation-markup-rule-dialog"
      @close="onCancel"
    >
      <div class="details-view">
        <div class="main-content">
          <!-- 基本信息区域 -->
          <div class="form-section">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="right">
              <div class="el-form-item-wrapper">
                <el-form-item label="委托方" prop="delegatorCode" class="el-form-item-w400">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Office_NoHQ"
                    :method-params="{}"
                    filterable
                    :disabled="isEditMode || isDetailMode"
                    :default-value="form.delegatorCode"
                    style="width: 100%"
                    placeholder="请选择"
                    @parentCallBack="p => {
                      form.delegatorCode = p.code;
                      form.delegatorName = p.chineseName || p.englishName || p.label || '';
                    }"
                  />
                </el-form-item>
                <el-form-item label="被委托方" prop="delegateeCode" class="el-form-item-w400">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Office_NoHQ"
                    :method-params="{}"
                    filterable
                    :disabled="isEditMode || isDetailMode"
                    :default-value="form.delegateeCode"
                    style="width: 100%"
                    placeholder="请选择"
                    @parentCallBack="p => {
                      form.delegateeCode = p.code;
                      form.delegateeName = p.chineseName || p.englishName || p.label || '';
                    }"
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>

          <!-- 费用维度区域 -->
          <div class="fee-section">
            <div class="section-header">
              <span class="section-title">费用维度</span>
              <el-button v-if="!isDetailMode" size="mini" type="primary" icon="el-icon-plus" @click="addFeeRow">新增</el-button>
            </div>
            <el-table
              :data="form.feeList"
              border
              stripe
              style="width: 100%"
              max-height="200"
            >
              <el-table-column type="index" label="序号" width="60" align="center" />
              <el-table-column label="费用名称" min-width="200">
                <template slot-scope="scope">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_ChargeItem"
                    :method-params="{}"
                    filterable
                    :disabled="isDetailMode"
                    :default-value="scope.row.feeId"
                    style="width: 100%"
                    placeholder="请选择"
                    @parentCallBack="p => {
                      scope.row.feeId = p.value || p.itemId;
                      scope.row.feeName = p.zhName || p.enName || p.label || '';
                    }"
                  />
                </template>
              </el-table-column>
              <el-table-column label="加价幅度（单价）" width="180">
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.markupAmount"
                    :precision="2"
                    :step="1"
                    :min="0"
                    :disabled="isDetailMode"
                    size="small"
                    style="width: 100%"
                  />
                </template>
              </el-table-column>
              <el-table-column v-if="!isDetailMode" label="操作" width="80" align="center">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click="deleteFeeRow(scope.$index)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 订单维度区域 -->
          <div class="job-section">
            <div class="section-header">
              <span class="section-title">订单维度</span>
              <el-button v-if="!isDetailMode" size="mini" type="primary" icon="el-icon-plus" @click="addJobRow">新增</el-button>
            </div>
            <el-table
              :data="form.jobList"
              border
              stripe
              style="width: 100%"
              max-height="300"
            >
              <el-table-column type="index" label="序号" width="60" align="center" />
              <el-table-column label="业务类型" width="120">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.businessType"
                    :disabled="isDetailMode"
                    size="small"
                    style="width: 100%"
                    placeholder="请选择"
                    @change="val => onBusinessTypeChange(scope.row, val)"
                  >
                    <el-option
                      v-for="item in businessTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="整拼类型" width="120">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.containerLoadType"
                    :disabled="isDetailMode || !isContainerLoadTypeEditable(scope.row.businessType)"
                    clearable
                    size="small"
                    style="width: 100%"
                    placeholder="请选择"
                    @change="val => onContainerLoadTypeChange(scope.row, val)"
                  >
                    <el-option
                      v-for="item in getContainerLoadTypes(scope.row.businessType)"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="加价单位" width="100">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.markupUnit"
                    :disabled="isDetailMode"
                    clearable
                    size="small"
                    style="width: 100%"
                    placeholder="请选择"
                    @change="val => onMarkupUnitChange(scope.row, val)"
                  >
                    <el-option
                      v-for="item in markupUnitOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="箱型" width="120">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.eqType"
                    :disabled="isDetailMode || scope.row.markupUnit !== 'EQ_TYPE'"
                    clearable
                    size="small"
                    style="width: 100%"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in eqTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="箱种" width="120">
                <template slot-scope="scope">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_EQType"
                    :method-params="{}"
                    :fields="['code']"
                    filterable
                    :disabled="isDetailMode || scope.row.markupUnit !== 'EQ_TYPE'"
                    :default-value="scope.row.eqKind"
                    tag-name="code"
                    tag-value="code"
                    style="width: 100%"
                    placeholder="请选择"
                    @parentCallBack="p => {
                      scope.row.eqKind = p.code;
                    }"
                  />
                </template>
              </el-table-column>
              <el-table-column label="币种" width="100">
                <template slot-scope="scope">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Currency"
                    :method-params="{}"
                    filterable
                    :disabled="isDetailMode"
                    :default-value="scope.row.currency"
                    style="width: 100%"
                    placeholder="请选择"
                    @parentCallBack="p => {
                      scope.row.currency = p.code;
                    }"
                  />
                </template>
              </el-table-column>
              <el-table-column label="单价" width="120">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.unitPrice"
                    :disabled="isDetailMode"
                    size="small"
                    style="width: 100%"
                    placeholder="请输入"
                    @input="val => onUnitPriceInput(scope.row, val)"
                  />
                </template>
              </el-table-column>
              <el-table-column v-if="!isDetailMode" label="操作" width="80" align="center">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click="deleteJobRow(scope.$index)"
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button v-if="!isDetailMode" size="mini" type="primary" @click="onSave()">保存</el-button>
        <el-button size="mini" @click="onCancel()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { query, save, update, remove, setEnabled, copy } from '@/api/sysManage/baseConfig/crossDelegationMarkupRule'
import { getGridSelected } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import { allLobSource } from '@/utils/selectData'

export default {
  name: 'CrossDelegationMarkupRule',
  components: {
    cargoAdvanceSelect
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      showDetail: false,
      isDetailMode: false,
      selectedRow: null,
      loading: null,
      dataLoaded: false,
      filter: {
        delegatorCode: '',
        delegateeCode: '',
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      rowData: [],
      gridParams: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500
      },
      columnDefs: [
        { headerName: '', width: 55, checkboxSelection: true, sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false, headerCheckboxSelection: true },
        { headerName: '委托方代码', field: 'delegatorCode', initialWidth: 140, minWidth: 140 },
        { headerName: '委托方名称', field: 'delegatorName', initialWidth: 180, minWidth: 180 },
        { headerName: '被委托方代码', field: 'delegateeCode', initialWidth: 140, minWidth: 140 },
        { headerName: '被委托方名称', field: 'delegateeName', initialWidth: 180, minWidth: 180 },
        { headerName: '创建人', field: 'createdByName', initialWidth: 120, minWidth: 120 },
        { headerName: '创建时间', field: 'dateCreated', initialWidth: 180, minWidth: 180 },
        { headerName: '修改人', field: 'modifiedByName', initialWidth: 120, minWidth: 120 },
        { headerName: '修改时间', field: 'dateModified', initialWidth: 180, minWidth: 180 },
        { headerName: '操作', field: 'operation', initialWidth: 280, minWidth: 280, suppressMenu: true, cellRenderer: params => this.renderOperationButtons(params) }
      ],
      form: {
        uuid: '',
        delegatorCode: '',
        delegatorName: '',
        delegateeCode: '',
        delegateeName: '',
        remark: '',
        feeList: [],
        jobList: []
      },
      rules: {
        delegatorCode: [{ required: true, message: '请输入委托方代码', trigger: 'blur' }],
        delegatorName: [{ required: true, message: '请输入委托方名称', trigger: 'blur' }],
        delegateeCode: [{ required: true, message: '请输入被委托方代码', trigger: 'blur' }],
        delegateeName: [{ required: true, message: '请输入被委托方名称', trigger: 'blur' }]
      },
      businessTypeOptions: [
        { label: '海运出口', value: 'SE' },
        { label: '海运进口', value: 'SI' },
        { label: '空运出口', value: 'AE' },
        { label: '空运进口', value: 'AI' },
        { label: '铁路出口', value: 'RE' },
        { label: '铁路进口', value: 'RI' },
        { label: '综合物流', value: 'IE' }
      ],
      markupUnitOptions: [
        { label: '票', value: 'TICKET' },
        { label: '箱数', value: 'BOX_COUNT' },
        { label: '箱型', value: 'EQ_TYPE' }
      ],
      eqTypeOptions: [
        { label: '20', value: '20' },
        { label: '40', value: '40' },
        { label: '45', value: '45' },
        { label: '10', value: '10' },
        { label: '53', value: '53' },
        { label: '30', value: '30' },
        { label: '48', value: '48' }
      ]
    }
  },
  computed: {
    dialogTitle() {
      if (this.isDetailMode) {
        return '详情'
      }
      if (this.form.uuid) {
        return '编辑'
      }
      return '新增'
    },
    isEditMode() {
      return !!this.form.uuid && !this.isDetailMode
    }
  },
  mounted() {
    this.$nextTick(() => {
      const gridWrapper = this.$refs.gridWrapper
      if (gridWrapper) {
        gridWrapper.addEventListener('click', this.handleButtonClick)
      }
    })
  },
  beforeDestroy() {
    const gridWrapper = this.$refs.gridWrapper
    if (gridWrapper) {
      gridWrapper.removeEventListener('click', this.handleButtonClick)
    }
  },
  methods: {
    loadData() {
      if (!this.dataLoaded) {
        this.dataLoaded = true
        this.toQuery()
      }
    },

    toQuery() {
      this.filter.pageNum = 1
      this.filter.total = 0
      this.fetchData()
    },
    fetchData() {
      this.loading = getLoading()
      const params = {
        likeName: '',
        delegatorCode: this.filter.delegatorCode,
        delegateeCode: this.filter.delegateeCode,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize
      }
      query(params).then(res => {
        if (res.ok) {
          this.rowData = res.data.list || []
          this.filter.total = res.data.total ? Number(res.data.total) : 0
        }
      }).finally(() => {
        this.loading.close()
      })
    },

    toCreate() {
      this.isDetailMode = false
      this.showDetail = true
      this.resetForm()
    },

    toCopy() {
      const gridApi = this.gridParams.api
      if (!gridApi) {
        this.$message.warning('请选择一条记录')
        return
      }

      const selectedRows = gridApi.getSelectedRows()

      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning('请勾选数据进行复制')
        return
      }

      if (selectedRows.length > 1) {
        this.$message.warning('只可勾选一条数据进行复制')
        return
      }

      const selectedRow = selectedRows[0]

      this.$confirm('确定要复制该规则吗？复制后的规则默认为禁用状态。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        copy(selectedRow.uuid).then(res => {
          if (res.ok) {
            this.$message.success('复制成功')
            this.fetchData()
          } else {
            this.$message.error(res.msg || '复制失败')
          }
        }).catch(err => {
          this.$message.error('复制失败：' + (err.message || '未知错误'))
        }).finally(() => {
          this.loading.close()
        })
      })
    },

    onSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.form.delegatorName) {
            this.$message.warning('请重新选择委托方')
            return
          }
          if (!this.form.delegateeName) {
            this.$message.warning('请重新选择被委托方')
            return
          }

          if (this.form.feeList && this.form.feeList.length > 0) {
            for (let i = 0; i < this.form.feeList.length; i++) {
              const fee = this.form.feeList[i]
              if (!fee.feeId) {
                this.$message.warning(`第${i + 1}行费用明细：请选择费用名称`)
                return
              }
              if (!fee.feeName) {
                this.$message.warning(`第${i + 1}行费用明细：请重新选择费用名称`)
                return
              }
            }
          }

          if (this.form.jobList && this.form.jobList.length > 0) {
            const keyMap = new Map()
            for (let i = 0; i < this.form.jobList.length; i++) {
              const job = this.form.jobList[i]
              const key = `${job.businessType || ''}_${job.containerLoadType || ''}`
              if (keyMap.has(key)) {
                const firstRow = keyMap.get(key)
                const businessTypeName = this.businessTypeOptions.find(opt => opt.value === job.businessType)?.label || job.businessType
                const containerLoadTypeName = this.getContainerLoadTypes(job.businessType).find(opt => opt.value === job.containerLoadType)?.label || job.containerLoadType || '空'
                this.$message.warning(`第${firstRow + 1}行与第${i + 1}行订单维度：业务类型「${businessTypeName}」+整拼类型「${containerLoadTypeName}」出现重复`)
                return
              }
              keyMap.set(key, i)
            }

            for (let i = 0; i < this.form.jobList.length; i++) {
              const job = this.form.jobList[i]
              if (!job.businessType) {
                this.$message.warning(`第${i + 1}行订单维度：请选择业务类型`)
                return
              }
              if (!job.markupUnit) {
                this.$message.warning(`第${i + 1}行订单维度：请选择加价单位`)
                return
              }
              if (!job.currency) {
                this.$message.warning(`第${i + 1}行订单维度：请选择币种`)
                return
              }
              if (job.unitPrice === null || job.unitPrice === undefined || job.unitPrice === '') {
                this.$message.warning(`第${i + 1}行订单维度：请输入单价`)
                return
              }
              if (job.markupUnit === 'EQ_TYPE') {
                if (!job.eqType) {
                  this.$message.warning(`第${i + 1}行订单维度：加价单位为箱型时，请选择箱型`)
                  return
                }
                if (!job.eqKind) {
                  this.$message.warning(`第${i + 1}行订单维度：加价单位为箱型时，请选择箱种`)
                  return
                }
              }
            }
          }

          const apiMethod = this.form.uuid ? update : save
          this.loading = getLoading()
          apiMethod(this.form).then(res => {
            if (res.ok) {
              this.$message.success(this.form.uuid ? '更新成功' : '新增成功')
              this.showDetail = false
              this.fetchData()
            }
          }).finally(() => {
            this.loading.close()
          })
        }
      })
    },

    onCancel() {
      this.showDetail = false
      this.isDetailMode = false
      this.resetForm()
    },

    addFeeRow() {
      this.form.feeList.push({
        uuid: '',
        feeId: null,
        feeName: '',
        markupAmount: 0
      })
    },

    deleteFeeRow(index) {
      this.form.feeList.splice(index, 1)
    },

    addJobRow() {
      this.form.jobList.push({
        uuid: '',
        businessType: 'SE',
        containerLoadType: '',
        containerLoadTypeName: '',
        markupUnit: '',
        eqType: '',
        eqKind: '',
        currency: '',
        unitPrice: 0
      })
    },

    deleteJobRow(index) {
      this.form.jobList.splice(index, 1)
    },

    onBusinessTypeChange(row, val) {
      row.containerLoadType = ''
      row.containerLoadTypeName = ''
    },

    onContainerLoadTypeChange(row, val) {
      const options = this.getContainerLoadTypes(row.businessType)
      const matched = options.find(item => item.value === val)
      row.containerLoadTypeName = matched ? matched.label : ''
    },

    onMarkupUnitChange(row) {
      // 切换加价单位时，清除箱型和箱种
      row.eqType = ''
      row.eqKind = ''
    },

    onUnitPriceInput(row, val) {
      // 只允许数字和小数点
      let value = val.replace(/[^\d.]/g, '')
      // 只允许一个小数点
      const dotIndex = value.indexOf('.')
      if (dotIndex !== -1) {
        value = value.substring(0, dotIndex + 1) + value.substring(dotIndex + 1).replace(/\./g, '')
      }
      // 限制小数点后最多两位
      const parts = value.split('.')
      if (parts.length === 2 && parts[1].length > 2) {
        value = parts[0] + '.' + parts[1].substring(0, 2)
      }
      // 不允许以多个0开头
      if (parts[0].length > 1 && parts[0].startsWith('0')) {
        value = value.replace(/^0+/, '')
      }
      row.unitPrice = value
    },

    isContainerLoadTypeEditable(businessType) {
      return ['SE', 'SI', 'RE', 'RI'].includes(businessType)
    },

    getContainerLoadTypes(businessType) {
      const isZh = this.$store.getters.language === 'zh'
      if (['SE', 'RE'].includes(businessType)) {
        return ContainerLoadType.CONTAINERLOAD_TYPES.map(item => ({
          value: item.code,
          label: isZh ? item.chineseName : item.englishName
        }))
      } else if (['SI', 'RI'].includes(businessType)) {
        return ImportConstants._cargoTypeInputList.map(item => ({
          value: item.code,
          label: isZh ? item.chineseName : item.englishName
        }))
      }
      return []
    },

    resetForm() {
      this.form = {
        uuid: '',
        delegatorCode: '',
        delegatorName: '',
        delegateeCode: '',
        delegateeName: '',
        feeList: [],
        jobList: []
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },

    onSelectionChanged(event) {
      const selectedRows = event.api.getSelectedRows()
      this.selectedRow = selectedRows.length > 0 ? selectedRows[0] : null
    },

    renderOperationButtons(params) {
      const row = params.data
      const isDisabled = row.enabled === '0'

      const buttons = []

      if (isDisabled) {
        buttons.push(
          `<button type="button" class="el-button el-button--primary el-button--mini action-btn" data-action="enable" data-uuid="${row.uuid}">启用</button>`
        )
        buttons.push(
          `<button type="button" class="el-button el-button--primary el-button--mini action-btn" data-action="edit" data-uuid="${row.uuid}">编辑</button>`
        )
        buttons.push(
          `<button type="button" class="el-button el-button--danger el-button--mini action-btn" data-action="delete" data-uuid="${row.uuid}">删除</button>`
        )
      } else {
        buttons.push(
          `<button type="button" class="el-button el-button--danger el-button--mini action-btn" data-action="disable" data-uuid="${row.uuid}">禁用</button>`
        )
        buttons.push(
          `<button type="button" class="el-button el-button--primary el-button--mini action-btn" data-action="detail" data-uuid="${row.uuid}">详情</button>`
        )
      }

      return `<div style="display: flex; gap: 4px;">${buttons.join('')}</div>`
    },

    handleButtonClick(event) {
      const target = event.target

      const button = target.closest('.action-btn')
      if (!button) {
        return
      }

      const action = button.getAttribute('data-action')
      const uuid = button.getAttribute('data-uuid')

      if (!action || !uuid) {
        return
      }

      switch (action) {
        case 'enable':
          this.handleEnable(uuid)
          break
        case 'disable':
          this.handleDisable(uuid)
          break
        case 'edit':
          this.handleEdit(uuid)
          break
        case 'delete':
          this.handleDelete(uuid)
          break
        case 'detail':
          this.handleDetail(uuid)
          break
        default:
          console.warn('Unknown action:', action)
      }
    },

    onCellClicked(event) {
      return
    },

    handleEnable(uuid) {
      this.loading = getLoading()
      setEnabled(uuid, true).then(res => {
        if (res.ok) {
          this.$message.success('启用成功')
          this.fetchData()
        } else {
          this.$message.error(res.msg || '启用失败')
        }
      }).catch(err => {
        this.$message.error('启用失败：' + (err.message || '未知错误'))
      }).finally(() => {
        this.loading.close()
      })
    },

    handleDisable(uuid) {
      this.loading = getLoading()
      setEnabled(uuid, false).then(res => {
        if (res.ok) {
          this.$message.success('禁用成功')
          this.fetchData()
        } else {
          this.$message.error(res.msg || '禁用失败')
        }
      }).catch(err => {
        this.$message.error('禁用失败：' + (err.message || '未知错误'))
      }).finally(() => {
        this.loading.close()
      })
    },

    handleEdit(uuid) {
      const row = this.rowData.find(item => item.uuid === uuid)
      if (!row) {
        this.$message.warning('未找到对应记录')
        return
      }
      this.isDetailMode = false
      this.showDetail = true
      this.form = {
        uuid: row.uuid,
        delegatorCode: row.delegatorCode || '',
        delegatorName: row.delegatorName || '',
        delegateeCode: row.delegateeCode || '',
        delegateeName: row.delegateeName || '',
        feeList: row.feeList || [],
        jobList: row.jobList || []
      }
    },

    handleDelete(uuid) {
      this.$confirm('是否确认删除当前记录?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        remove(uuid).then(res => {
          if (res.ok) {
            this.$message.success('删除成功')
            this.fetchData()
          }
        }).finally(() => {
          this.loading.close()
        })
      })
    },

    handleDetail(uuid) {
      const row = this.rowData.find(item => item.uuid === uuid)
      if (!row) {
        this.$message.warning('未找到对应记录')
        return
      }
      this.isDetailMode = true
      this.showDetail = true
      this.form = {
        uuid: row.uuid,
        delegatorCode: row.delegatorCode || '',
        delegatorName: row.delegatorName || '',
        delegateeCode: row.delegateeCode || '',
        delegateeName: row.delegateeName || '',
        feeList: row.feeList || [],
        jobList: row.jobList || []
      }
    }
  }
}
</script>

<style lang="scss">
.cross-delegation-markup-rule {
  .el-form-item-w320 {
    width: 320px;
    margin-right: 20px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 240px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
}

.cross-delegation-markup-rule-dialog {
  .el-dialog__body {
    font-size: 12px;
    padding: 10px;
    min-height: 400px;
  }

  .form-section {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
  }

  .fee-section {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .section-title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
      }
    }
  }

  .job-section {
    margin-bottom: 20px;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .section-title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
      }
    }
  }

  .el-form-item-w400 {
    width: 400px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 280px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }

  .el-table .el-select__placeholder {
    color: #c0c4cc !important;
  }

  .el-table .el-input__placeholder {
    color: #c0c4cc !important;
  }

  .el-table .el-select.is-disabled .el-select__placeholder {
    color: #c0c4cc !important;
  }

  .el-table .el-input.is-disabled .el-input__inner::placeholder {
    color: #c0c4cc !important;
  }
}

.action-btn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  user-select: none;
  padding: 7px 15px;
  font-size: 12px;
  border-radius: 3px;

  &:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }

  &.el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;

    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
      color: #fff;
    }
  }

  &.el-button--success {
    color: #fff;
    background-color: #67c23a;
    border-color: #67c23a;

    &:hover {
      background: #85ce61;
      border-color: #85ce61;
      color: #fff;
    }
  }

  &.el-button--warning {
    color: #fff;
    background-color: #e6a23c;
    border-color: #e6a23c;

    &:hover {
      background: #ebb563;
      border-color: #ebb563;
      color: #fff;
    }
  }

  &.el-button--danger {
    color: #fff;
    background-color: #f56c6c;
    border-color: #f56c6c;

    &:hover {
      background: #f78989;
      border-color: #f78989;
      color: #fff;
    }
  }
}
</style>
